/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import type { ReactNode } from 'react';
import { splitAlertMessage } from './alertMessage';

interface Props {
  content: ReactNode;
  /** Shown under the text, e.g. the Details link of warnings and errors. */
  action?: ReactNode;
}

/**
 * Alert text: "title: detail" strings become a bold title plus a one-line detail. Custom JSX
 * (e.g. useAPIErrorHandler's message with a View button) renders as-is in a block container,
 * without the single-line title truncation.
 */
export default function AlertToastMessage({ content, action }: Readonly<Props>) {
  if (typeof content !== 'string') {
    return (
      <div className="alert-toast-text alert-toast-custom">
        {content}
        {action}
      </div>
    );
  }
  const { title, detail } = splitAlertMessage(content);
  return (
    <div className="alert-toast-text">
      <span className="alert-toast-title">{title}</span>
      {detail && <span className="alert-toast-detail">{detail}</span>}
      {action}
    </div>
  );
}
